import { resolveComponent as _resolveComponent, withModifiers as _withModifiers, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "tooltip",
  "x-placement": "bottom"
}
const _hoisted_2 = { class: "tooltip-inner" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_rc_icon_tooltip = _resolveComponent("rc-icon-tooltip")!

  return (_openBlock(), _createElementBlock("div", {
    ref: "container",
    class: _normalizeClass(["labeled-tooltip", {[_ctx.status]: true, hoverable: _ctx.hover}])
  }, [
    (_ctx.hover)
      ? (_openBlock(), _createBlock(_component_rc_icon_tooltip, {
          key: 0,
          content: _ctx.tooltipContent,
          label: _ctx.iconAriaLabel,
          "icon-type": _ctx.iconType,
          class: _normalizeClass([{'hover':!_ctx.value}, "status-icon"]),
          "data-testid": _ctx.componentTestid,
          onClick: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["stop"]))
        }, null, 8, ["content", "label", "icon-type", "class", "data-testid"]))
      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          _createElementVNode("i", {
            class: _normalizeClass([{'hover':!_ctx.value}, "icon status-icon"])
          }, null, 2),
          _cache[3] || (_cache[3] = _createTextVNode()),
          (_ctx.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _cache[1] || (_cache[1] = _createElementVNode("div", { class: "tooltip-arrow" }, null, -1)),
                _cache[2] || (_cache[2] = _createTextVNode()),
                _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.value), 1)
              ]))
            : _createCommentVNode("", true)
        ], 64))
  ], 2))
}